// Module
var code = `<div class="{{.elementStyle}} {{.additionalClass}} {{#.haveError}}js-input-container-error{{/}}" on-mousedown="@this.onMouseDown(event)"
    style="{{>visibility}} {{#if .isPosAbsolute}}position: absolute; {{>position}}{{/if}}" {{>visualparameters}}>
    <form autocomplete="off" on-submit="@this.onSubmitEvent(event)">
        <input type={{inputType}}
        maxlength="{{.maxLength}}"
        placeholder=""
        spellcheck="false"
        value="{{.text}}"
        as-tooltip="tooltip"
        on-focus="focus"
        on-blur="blur"
        on-keydown="keyDown"
        on-keyup="keyUp"
        on-wheel="mouseWheel"
        on-mousewheel="mouseWheel"
        {{#.autofocus}} autofocus {{/}}
        {{#.isReadOnly}} readonly {{/}}
        autocomplete="off"
        class="{{isMaterialDesign ? 'material-input' : ''}}"
        id="{{getInputId}}"/>
        <label for="{{getInputId}}">
            {{#if svgIcon }}
                <svg>
                    <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{svgIcon}}"></use>
                </svg>
            {{/if}}

            <span>{{placeholder}}</span>
        </label>
    </form>
</div>`;
// Exports
export default code;